import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux'
import {DropdownButton, MenuItem, Button, Modal} from "react-bootstrap";
import {URLs} from "../../common/constants";
import {getPageContext, addPath, redirectPage} from '../../common/utils';
import {checkIsDirty, setDirty} from '../../actions/common/commonActions';
import {logOut} from '../../actions/login/logInActions';
import ContactFarmModal from '../../components/common/ContactFarmModal';
import styles from "../../css/user-menu.less";
import {translate} from "../../i18n/translate.js";
import {saveDraftOrder} from "../../actions/store/storeActions";

class LogInWidget extends React.Component {
    state = {showContactUs: false,
            showUserMenu: false};

    onLogInClicked = () => {
        this.closeUserMenuXs();
        this.props.goToLogin();
    };

    onLogOutClick = () => {
        this.closeUserMenuXs();
        this.props.checkIsDirty(function() {
            this.props.logOut();
        }.bind(this));
    };

    onMyAccountClick = () => {
        this.props.checkIsDirty(function() {
            this.props.goToAccount(this.props.staticData);
            }.bind(this));
    };

    onDeliveryHoldClick = () => {
        this.props.checkIsDirty(function() {
            this.props.goToDeliveryHold(this.props.staticData);
            }.bind(this));
    };

    onStoreClick = () => {
        this.props.checkIsDirty(function() {
            this.props.goToStore(this.props.staticData);
        }.bind(this));
    };

    onWebSiteClick = () => {
        this.props.goToWebSite(this.props.farmWebSiteUrl);
    };

    onContactUsClick = () => {
        this.closeUserMenuXs();
        this.setState({showContactUs: true});
    };

    onContactUsClose = () => {
        this.setState({showContactUs: false});
    };

    showUserMenuXs = () => {
        this.setState({showUserMenu: true});
    };

    closeUserMenuXs = () => {
        this.setState({showUserMenu: false});
    };

    renderContactFarmModal = () => {
        if (!this.state.showContactUs)
            return null;
        return (
            <ContactFarmModal farmEmail={this.props.farmEmail}
                              farmWebSiteUrl={this.props.farmWebSiteUrl}
                              farmName={this.props.farmName}
                              farmPhone={this.props.farmPhone}
                              onClose={this.onContactUsClose}/>
        )
    };

    renderUserMenuXs = () => {
        if (this.props.memberDetails.firstName)
            return (
                <div>
                    <div className="menu-title"><div>{this.props.memberDetails.firstName + " " + this.props.memberDetails.lastName}</div></div>
                    {this.getLink()}
                    <MenuItem eventKey="contactUs" onClick={this.onContactUsClick}>{translate('Contact Us')}</MenuItem>
                    <MenuItem eventKey="website" onClick={this.onWebSiteClick}>{translate('Web Site')}</MenuItem>
                    <MenuItem eventKey="logOut" onClick={this.onLogOutClick}>{translate('Log Out')}</MenuItem>
                </div>
            );
        return (
            <div>
                {getPageContext() !== URLs.JOIN ?
                    <MenuItem eventKey="login" onClick={this.onLogInClicked}>{translate('Log In')}</MenuItem>
                    :
                    undefined
                }
                <MenuItem eventKey="contactUs" onClick={this.onContactUsClick}>{translate('Contact Us')}</MenuItem>
                <MenuItem eventKey="website" onClick={this.onWebSiteClick}>{translate('Web Site')}</MenuItem>
            </div>
        )
    };

    renderXs = () => {
        return (
            <div className="user-menu">
                <div className="humburger-button" onClick={this.showUserMenuXs}><i/></div>
                {this.renderContactFarmModal()}
                <Modal className="user-menu-modal" show={this.state.showUserMenu} onHide={this.closeUserMenuXs}>
                    <Modal.Body>
                        {this.renderUserMenuXs()}
                    </Modal.Body>
                </Modal>
            </div>
        )
    };

    getLink = () => {
        if (this.props.showGoToStore && this.props.isStoreAvailable) {
            return (<MenuItem eventKey="goto" onClick={this.onStoreClick}>{translate(this.props.staticData.storeButtonLabel)}</MenuItem>);
        } else if (!this.props.showGoToStore) {
            const menuItems = [<MenuItem key="myAccount" eventKey="myAccount" onClick={this.onMyAccountClick}>{translate('My Account')}</MenuItem>];
            if (this.props.staticData.allowUpdateVacation) {
                menuItems.push(<MenuItem key="deliveryHold" eventKey="deliveryHold" onClick={this.onDeliveryHoldClick}>{translate('Delivery Hold')}</MenuItem>)
            }
            return (menuItems);
        }
    };

    renderMd = () => {
        if (this.props.memberDetails.firstName)
            return (
                <div className="user-menu">
                    <DropdownButton className="menu-title hidden-xs"
                                    title={this.props.memberDetails.firstName}
                                    id="member-menu">
                        {this.getLink()}
                        <MenuItem eventKey="contactUs" onClick={this.onContactUsClick}>{translate('Contact Us')}</MenuItem>
                        <MenuItem eventKey="logOut" onClick={this.onLogOutClick}>{translate('Log Out')}</MenuItem>
                    </DropdownButton>
                    {this.renderContactFarmModal()}
                </div>
            );
        else
            return (
                <div className="user-menu">
                    <Button className="no-dropdown" onClick={this.onLogInClicked} id="login-button">{translate('Log In')}</Button>
                </div>
            );

    };

    render() {
        if (this.props.clientViewPort.isXs)
            return this.renderXs();
        return this.renderMd();
    }
}

const mapStateToProps = (state) => {
    const summary = state.summary || {};
    return {
        staticData: state.staticData,
        clientViewPort: (state.clientViewPort || {}),
        memberDetails: (state.memberDetails || {}),
        farmName: state.staticData.farmName,
        farmEmail: state.staticData.farmEmail,
        farmPhone: state.staticData.farmPhone,
        farmWebSiteUrl: state.staticData.farmWebSiteUrl,
        showGoToStore: getPageContext() === URLs.ACCOUNT,
        isStoreAvailable: summary.isStoreAvailable
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        checkIsDirty: (onLeaveCallBack) => {
            dispatch(checkIsDirty(onLeaveCallBack));
        },
        logOut: () => {
            if (ownProps.disabled)
                return;
            dispatch(setDirty(false));
            dispatch(logOut());
        },
        goToAccount: (staticData) => {
            if (ownProps.disabled)
                return;
            dispatch(setDirty(false));
            window.location.assign(redirectPage(URLs.ACCOUNT, staticData));
        },
        goToDeliveryHold: (staticData) => {
            if (ownProps.disabled)
                return;
            dispatch(setDirty(false));
            window.location.assign(redirectPage(URLs.ACCOUNT, staticData, '?tab=Delivery Hold'));
        },
        goToStore: (staticData) => {
            if (ownProps.disabled)
                return;
            dispatch(setDirty(false));
            window.location.assign(redirectPage(URLs.STORE, staticData));
        },
        goToLogin: () => {
            if (ownProps.disabled)
                return;
            dispatch(saveDraftOrder(true));
            dispatch(setDirty(false));
            dispatch(push(addPath('login')))
        },
        goToWebSite: (webSiteUrl) => {
            window.location.assign(webSiteUrl)
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LogInWidget);




// WEBPACK FOOTER //
// ./src/containers/common/UserMenu.js